import React from 'react';
import { Ban } from 'lucide-react';

export default function BanScreen({ message, onLogout }) {
  return (
    <div className="login-screen ban-screen">
      <div className="bg-mesh" />
      <div className="glass glass-elevated ban-card anim-rise">
        <Ban size={40} className="ban-icon" />
        <h1 className="ban-title">Access restricted</h1>
        <p className="ban-msg">{message || 'This account cannot use InboxPulse right now.'}</p>
        <p className="ban-hint">
          Automated protection limits accounts that show patterns consistent with burning through paid AI credits. If you
          believe this is a mistake, contact support.
        </p>
        <button type="button" className="btn btn-primary" onClick={onLogout}>
          Sign out
        </button>
      </div>
    </div>
  );
}
